module.exports = __webpack_public_path__ + "media/images/tiedye_small-b37604ce.gif";